/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { memo, useState } from "react";

import CalendarTable from "./CalendarTable";
import PrevButton from "./PrevButton";
import NextButton from "./NextButton";
import { mtgList, mtgListContents, mtgGroup } from "assets/css/stylesCss";
import { telLink } from "assets/css/shchMtmr";

/**
 * カレンダー
 * @param {Object} kbuHmDayInfo カレンダー情報
 * @param {Setter} setKbuHmDayInfo カレンダー情報をセット
 * @param {String} tntShopTelNo 担当店舗のお問い合わせ先電話番号
 */
const Calendar = memo(
  ({
    kbuHmDayInfo,
    setKbuHmDayInfo,
    tntShopTelNo,
    addressKj,
    setIsActive,
    setIsOutOfServiceArea,
    setNoCapacity,
  }) => {
    // カレンダーページ
    const [page, setPage] = useState(
      kbuHmDayInfo.selectedPage ? kbuHmDayInfo.selectedPage : 0
    );

    return (
      <>
        {/** カレンダー本体 */}
        <CalendarTable
          page={page}
          kbuHmDayInfo={kbuHmDayInfo}
          setKbuHmDayInfo={setKbuHmDayInfo}
          addressKj={addressKj}
          setIsActive={setIsActive}
          setIsOutOfServiceArea={setIsOutOfServiceArea}
          setNoCapacity={setNoCapacity}
        ></CalendarTable>

        {/** メッセージ */}
        <div css={mtgGroup}>
          <ul css={mtgList}>
            <li css={mtgListContents}>
              お申し込み状況、商材によっては、日程を再調整させていただく場合がございます。
            </li>
            <li css={mtgListContents}>
              お急ぎのお客さまは、最寄りのライフバル・エネスタまで
              <a href={"tel:" + tntShopTelNo} css={telLink}>
                お電話
              </a>
              にてお問い合わせください。
            </li>
            <li css={mtgListContents}>
              ガス栓増設のご相談は本ページでは受付できないため、
              <a href={"tel:" + tntShopTelNo} css={telLink}>
                お電話
              </a>
              にてお問い合わせください。
            </li>
          </ul>
        </div>

        {/* 【前の1週間】ボタン */}
        <PrevButton
          name="cell"
          page={page}
          fn={() => setPage(Number(page) - 1)}
        />

        {/* 【次の1週間】ボタン */}
        <NextButton
          name="cell"
          page={page}
          fn={() => setPage(Number(page) + 1)}
        />
      </>
    );
  }
);

export default Calendar;
